import { Download } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { encodeUrl } from '../../common/helpers';
import GetSettlementsReportQuery from './GetSettlementsReportQuery';
import UI from '../../common/UI';
import config from '../../config';
import useLocale from '../../common/useLocale';
import useProject from '../useProject';
import useQuery from '../../api/useQuery';
import useUrlState from '../../common/useUrlState';

const SettlementsReport = () => {
  const { t } = useTranslation();
  const project = useProject();
  const { formatCurrency, formatDate, parseDate } = useLocale();

  const { data } = useQuery(GetSettlementsReportQuery, {
    variables: {
      project: project.id,
    },
  });

  const [urlState] = useUrlState({
    parse: (params, { integer }) => ({
      ...params,
      page: integer(params.page, 1),
    }),
  });

  if (!data) {
    return <UI.PageLoader />;
  }

  const settlements = data.project.settlements.slice((urlState.page - 1) * 10, urlState.page * 10);
  const pageCount = Math.ceil(data.project.settlements.length / 10);

  return (
    <UI.GridContainer>
      <UI.GridContainer sc={{ gutter: 0.5 }}>
        {settlements.map((settlement) => (
          <UI.GridContainer sc={{ columns: ['1fr', '1fr 1fr'] }} key={settlement.id}>
            <UI.Div>
              <UI.Strong sc={{ color: 'gray.800', block: true }}>
                {settlement.reference}
              </UI.Strong>
              <UI.Delimit>
                {formatDate(
                  parseDate(settlement.settled_at, { timezone: 'UTC' }),
                  { format: 'display_compact_date' },
                )}
                {formatCurrency(settlement.amount)}
              </UI.Delimit>
            </UI.Div>
            <UI.Div sc={{ textAlign: 'right' }}>
              <UI.AButton
                href={`${config.backendPath}/api/settlement/${settlement.id}/pdf`}
                target="_blank"
                rel="noopener noreferrer"
                sc={{ size: 'sm' }}
              >
                <UI.Icon>
                  <Download />
                </UI.Icon>
                {' PDF'}
              </UI.AButton>
              {' '}
              <UI.AButton
                href={`${config.backendPath}/api/revenue/${project.id}/csv?${encodeUrl({ settlements: [settlement.id] })}`}
                target="_blank"
                rel="noopener noreferrer"
                sc={{ size: 'sm' }}
              >
                <UI.Icon>
                  <Download />
                </UI.Icon>
                {' CSV'}
              </UI.AButton>
            </UI.Div>
          </UI.GridContainer>
        ))}
        {settlements.length === 0 && t('no_settlements_yet')}
      </UI.GridContainer>
      {pageCount > 1 && (
        <>
          <UI.HR />
          <UI.Pager pageCount={pageCount} />
        </>
      )}
    </UI.GridContainer>
  );
};

export default SettlementsReport;
